module.exports = __webpack_public_path__ + "static/media/Normas_banners_IIIMostra.906faddd.pdf";